import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FcCalendar, FcDocument, FcViewDetails } from "react-icons/fc";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { SortingRule } from "react-table";
import { Col, Row } from "reactstrap";
import { AssistanceUtilities } from "../../../AssistanceUtilities";
import ButtonComponent from "../../../components/ButtonComponent";
import InputComponent from "../../../components/InputComponent";
import MultiSelectComponent from "../../../components/MultiSelectComponent";
import { SelectItemsProps } from "../../../components/SearchSelectComponent";
import SelectComponent from "../../../components/SelectComponent";
import TableComponent from "../../../components/TableComponent";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceListDTO } from "../../../models/Assistance/AssistanceListDTO";
import { CreateAssistanceDTO } from "../../../models/Assistance/CreateAssistanceDTO";
import { Parameter } from "../../../models/Parameter";
import { useNavigateToScheduleCreate } from "../../../ScheduleUtilities";
import { AssistanceService } from "../../../services/AssistanceService";
import { generatePDF } from "../../GeneratePDF";

export default function AssistanceIndexA({ ...props }) {
    const intl = useIntl();
    const navigate = useNavigate();
    const service = new AssistanceService();
    const navigateToScheduleCreate = useNavigateToScheduleCreate();

    // módulos
    const { availableModules, assistanceTypes, statusOptions } = useAvailableModulesContext();
    const [isActiveFabricationModule, setIsActiveFabricationModule] = useState<boolean>(false);
    const [isActiveProjectModule, setIsActiveProjectModule] = useState<boolean>(false);
    const [isActiveSchedulerModule, setIsActiveSchedulerModule] = useState<boolean>(false);
    const [isActiveOutsourcingModule, setIsActiveOutsourcingModule] = useState<boolean>(false);
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    const [isActivePriorityModule, setIsActivePriorityModule] = useState<boolean>(false);
    const [isActiveErpSupportModule, setIsActiveErpSupportModule] = useState<boolean>(false);
    const [isActiveWorkshopInternalNumber, setIsActiveWorkshopInternalNumber] = useState<boolean>(false);

    const pageSizes: number[] = [5, 10, 15, 30];
    const [page] = useState<number>(Utilities.LoadPageFromURLQuery("page"));
    const [pageSize] = useState<number>(Utilities.LoadPageSizeFromURLQuery(pageSizes, 10));
    const [data, setData] = useState<AssistanceListDTO[]>([]);
    const [pageCount, setPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState<number>();
    const [currentPageSize, setCurrentPageSize] = useState<number>();
    const [currentSorting, setCurrentSorting] = useState<SortingRule<object>[] | null>(null);
    const [initialSortBy] = useState<SortingRule<object>[]>(Utilities.LoadSortParametersFromURLQuery("sortField", "sortOrder"));
    const [goToPage, setGoToPage] = useState<number>();

    const [reloadSearch, setReloadSearch] = useState<boolean>(false);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const [clientSearch, setClientSearch] = useState<string>(Utilities.LoadParameterFromURLQuery("clientSearch", "string", ""));
    const [serialNumber, setSerialNumber] = useState<string>(Utilities.LoadParameterFromURLQuery("serialNumber", "string", ""));
    const [numDoc, setNumDoc] = useState<string>(Utilities.LoadParameterFromURLQuery("numDoc", "string", ""));
    const [project, setProject] = useState<string>(Utilities.LoadParameterFromURLQuery("project", "string", ""));
    const [status, setStatus] = useState<string>(Utilities.LoadParameterFromURLQuery("status", "string", statusOptions));
    const [selectedTechnician, setSelectedTechnician] = useState<string>(Utilities.LoadParameterFromURLQuery("technician", "string", ""));
    const [techninians, setTechnicians] = useState<SelectItemsProps[]>([]);
    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", availableModules.includes("ShowAssistanceDefaultFilters") === true ? "Reparação" : ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);
    const [selectedSubcontractor, setSelectedSubcontractor] = useState<string>(Utilities.LoadParameterFromURLQuery("subcontractor", "string", ""));
    const [initialDate, setInitialDate] = useState<string>(Utilities.LoadParameterFromURLQuery("initialDate", "string", ""));
    const [endDate, setEndDate] = useState<string>(Utilities.LoadParameterFromURLQuery("endDate", "string", ""));
    const [carPlate, setCarPlate] = useState<string>(Utilities.LoadParameterFromURLQuery("carPlate", "string", ""));
    const [supportNumber, setSupportNumber] = useState<string>(Utilities.LoadParameterFromURLQuery("supportNumber", "string", ""));

    const [selectedAssistancePriority, setSelectedAssistancePriority] = useState<string>("");
    const [assistancePriority, setAssistancePriority] = useState<SelectItemsProps[]>([]);

    const [listStatus, setListStatus] = useState<SelectItemsProps[]>([]);

    //modulos ativos
    useEffect(() => {
        if (availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
            setIsActiveProjectModule(true);
        }
        if (availableModules.includes("FabricationSage50cIsActiveFabricationModule")) {
            setIsActiveFabricationModule(true);
        }
        if (availableModules.includes("IsActiveScheduler")) {
            setIsActiveSchedulerModule(true);
        }
        if (availableModules.includes("IsActiveOutsourcingModule")) {
            setIsActiveOutsourcingModule(true);
        }
        if (availableModules.includes("IsActiveScheduler")) {
            setIsActiveSchedulerModule(true);
        }
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
        if (availableModules.includes("IsActivePriorityModule")) {
            setIsActivePriorityModule(true);
        }        
        if (availableModules.includes("IsActiveErpSupportModule")) {            
            setIsActiveErpSupportModule(true);
        }
        if (availableModules.includes("IsActiveWorkshopInternalNumber")) {
            setIsActiveWorkshopInternalNumber(true);
        }             
    }, [availableModules]);

    const columns = React.useMemo(() => {
        const commonColumns = [
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    const isValidAssistanceStatusForScheduling = AssistanceUtilities.IsValidAssistanceStatusForScheduling(props.cell.row.original.status);
                    return (
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Ver Detalhes" aria-label="Ver Detalhes" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        const projectErpId = props.cell.row.original.project?.erpId || null;
                                        const equipmentErpId = props.cell.row.original.equipment?.erpId || null;
                                        const equipmentSerialNumber = props.cell.row.original.equipment?.serialNumber || null;
                                        const equipmentBrand = props.cell.row.original.equipment?.brand || null
                                        const equipmentModel = props.cell.row.original.equipment?.model || null;
                                        const clientErpId = props.cell.row.original.client?.erpId || null;
                                        const docNumber = props.cell.row.original.number || null;
                                        const docType = props.cell.row.original.docType || null;
                                        const docSerie = props.cell.row.original.serie || null;
                                        const budgetSellingPrice = props.cell.row.original.budgetSellingPrice || null;
                                        const budgetCostPrice = props.cell.row.original.budgetCostPrice || null;
                                        const supportNumber  = props.cell.row.original.supportNumber || null;
                                        createAssistance(projectErpId, equipmentErpId, equipmentSerialNumber, equipmentBrand, equipmentModel, clientErpId,
                                            docNumber, docType, docSerie, budgetSellingPrice, budgetCostPrice, supportNumber
                                        );
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>

                            {isActiveSchedulerModule && isValidAssistanceStatusForScheduling &&
                                <Tooltip title="Agendar" aria-label="Agendar" enterNextDelay={500} enterDelay={500}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            flexDirection: "column",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => navigateToScheduleCreate(
                                            props.cell.row.original.assistanceId,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie,
                                            props.cell.row.original.number,
                                            props.cell.row.original.client,
                                            props.cell.row.original.equipment
                                        )}
                                    >
                                        <FcCalendar className="icons" />
                                    </div>
                                </Tooltip>
                            }

                            <Tooltip title="Relatório" aria-label="Relatório" enterNextDelay={500} enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        generatePDF(
                                            props.cell.row.original.number,
                                            props.cell.row.original.docType,
                                            props.cell.row.original.serie,
                                        );
                                    }}
                                >
                                    <FcDocument className="icons" />
                                </div>
                            </Tooltip>

                        </div>
                    );
                },
                width: 5
            },
            {
                Header: "Id",
                width: 7.5,
                Cell: (props: any) => {
                    return Utilities.FormattedAssistanceDocument(props.cell.row.original.docType, props.cell.row.original.serie, props.cell.row.original.number);
                },
            },
            {
                Header: "Data",
                accessor: "date",
                width: 7.5,
                Cell: (props: any) => {
                    return props.cell.row.original.dateString;
                },
            },
            {
                Header: "Cliente",
                accessor: "client.name",
                width: 15,
            },
            ...(isActiveCarPlate ? [{
                Header: "Matrícula",
                accessor: "equipment.carPlate",
                width: 8,
            }] : []),
            {
                Header: "Nº Série",
                accessor: "equipment.serialNumber",
                width: 8,
            },
            {
                Header: "Marca",
                accessor: "equipment.brand",
                width: 8,
            },
            {
                Header: "Modelo",
                accessor: "equipment.model",
                width: 8,
            },
            {
                Header: "Técnico",
                accessor: "technician",
                width: isActiveProjectModule || isActiveOutsourcingModule ? 10 : 15,
            },
            {
                Header: "Estado",
                accessor: "status",
                width: 15,
            },
            {
                Header: "Tipo de Assistência",
                accessor: "assistanceType",
                width: 10,
            },
        ];

        if (isActiveWorkshopInternalNumber) {
            commonColumns.splice(2,0,{
                Header: "Número",
                accessor: "workshopInternalNumber",
                width: 7.5,
            });
        }

        if (isActivePriorityModule) {
            commonColumns.push({
                Header: "Prioridade",
                accessor: "priority",
                width: 15,
            });
        }

        if (isActiveProjectModule) {
            commonColumns.push({
                Header: "Obra",
                accessor: "project.description",
                width: 15,
            });
        }

        if (isActiveOutsourcingModule) {
            commonColumns.push({
                Header: "Subcontratante",
                accessor: "subcontractor",
                width: 15,
            });
        }
        if (isActiveErpSupportModule) {
            commonColumns.splice(2,0,{
                Header: "Pat Num",
                accessor: "supportNumber",
                width: 7.5,
            });
        }


        return commonColumns;
    }, [isActiveFabricationModule, isActiveProjectModule, isActiveSchedulerModule, isActiveOutsourcingModule, isActiveCarPlate, isActivePriorityModule, isActiveErpSupportModule, isActiveWorkshopInternalNumber]);


    const ListClosed: SelectItemsProps[] = [
        {
            label: "Sim",
            value: "1",
        },
        {
            label: "Não",
            value: "0",
        },
    ];

    const getStatus = async () => {
        var response = await service.GetStatus();
        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        var items: SelectItemsProps[] = [];
        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.enumValue,
                label: element.name,
            };
            items.push(item);
        });

        setListStatus(items);
    };

    //obter prioridades da assistência
    const getPriorities = async () => {
        const list: SelectItemsProps[] = [];
        const priorityList: number[] = [1, 2, 3];

        priorityList.forEach((priority) => {
            const item: SelectItemsProps = {
                value: priority.toString(),
                label: priority.toString(),
            };
            list.push(item);
        });


        setAssistancePriority(list);
    };

    const getTechnicians = async () => {
        const list: SelectItemsProps[] = [];
        var response = await service.GetWorkshopTechniciansWithCode();

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.id,
                label: element.name,
            };
            list.push(item);
        });

        setTechnicians(list);
    };

    const getAssistanceTypes = async () => {
        const list: SelectItemsProps[] = [];

        assistanceTypes.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setAssistanceTypesComponent(list);
    };

    const createAssistance = async (projectErpId: string | null, equipmentErpId: string, equipmentNumSerie: string, equipmentBrand: string, equipmentModel: string, clientErpId: string, numDoc: number, typeDoc: string, serie: string, budgetSellingPrice: number, budgetCostPrice: number, supportNumber: string | null  ) => {
        var sendData: CreateAssistanceDTO = {
            equipmentErpId: equipmentErpId,
            equipmentNumSerie: equipmentNumSerie,
            equipmentBrand: equipmentBrand,
            equipmentModel: equipmentModel,
            projectErpId: projectErpId,
            clientErpId: clientErpId,
            numDoc: numDoc,
            typeDoc: typeDoc,
            serie: serie,
            id: 0,
            date: new Date(),
            description: null,
            notes: null,
            clientId: null,
            counter1: 0,
            counter2: 0,
            counter3: 0,
            assistanceType: null,
            stockEntryDocumentErpId: null,
            budgetSellingPrice: budgetSellingPrice,
            budgetCostPrice: budgetCostPrice,
            supportNumber : supportNumber
        };

        setIsButtonCreateLoading(true);
        var response = await service.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        navigate(`/Backoffice/Assistance/${response.obj}`);
    };

    const fetchData = async (page: number, pageSize: number, sortBy: SortingRule<object>[] | null) => {
        var searchUrl: string = constructSearchUrl(page, pageSize, sortBy);

        navigate({
            pathname: "/Backoffice",
            search: searchUrl,
        }, {replace: true });

        props.setLoading(true);
        var response = await service.GetAll(
            mountSearchParameters(),
            Utilities.MountSortParameters(sortBy),
            page,
            pageSize,
        );

        if (response.success !== true) {
            setCurrentPage(1);
            setGoToPage(1);
            setData([]);
            setPageCount(0);
            props.setLoading(false);
            setCurrentSorting(null);
            Toast.Show("error", response.message);
            return;
        }

        if (response.items.length === 0) {
            setCurrentPage(1);
            setGoToPage(1);
            Toast.Show("info", "Não existe nenhuma assistência com esses dados");
        }

        setData(response.items);
        setPageCount(response.totalPages);
        props.setLoading(false);
        setCurrentPageSize(pageSize);
        setCurrentPage(page);
        setCurrentSorting(sortBy);
        setGoToPage(0)

        if (response.totalPages > 0 && page > response.totalPages) {
            setGoToPage(1);
        }
    };

    const constructSearchUrl = (page: number, pageSize: number, sortBy: SortingRule<object>[] | null): string => {
        var searchUrl: string = Utilities.CreateSearchURL([
            `page=${page}`,
            `pageSize=${pageSize}`,
            Utilities.AddParamToQueryIfValue("clientSearch", "string", clientSearch),
            Utilities.AddParamToQueryIfValue("serialNumber", "string", serialNumber),
            Utilities.AddParamToQueryIfValue("numDoc", "string", numDoc),
            Utilities.AddParamToQueryIfValue("project", "string", project),
            Utilities.AddParamToQueryIfValue("status", "string", status),
            Utilities.AddParamToQueryIfValue("technician", "string", selectedTechnician),
            Utilities.AddParamToQueryIfValue("assistanceType", "string", selectedAssistanceType),
            Utilities.AddParamToQueryIfValue("initialDate", "string", initialDate),
            Utilities.AddParamToQueryIfValue("endDate", "string", endDate),
            Utilities.AddParamToQueryIfValue("carPlate", "string", carPlate),
            Utilities.AddParamToQueryIfValue("priority", "string", selectedAssistancePriority),
        ]);

        if (sortBy != null && sortBy.length > 0) {
            searchUrl += `${Utilities.AddParamToQueryIfValue("sortField", "string", sortBy[0].id)}${Utilities.AddParamToQueryIfValue(
                "sortOrder", "string", sortBy[0].desc === true ? "DESC" : "ASC",
            )}`;
        }

        return searchUrl;
    }

    const mountSearchParameters = (): Parameter[] => {
        var parameters: Parameter[] = [];
        parameters.push(new Parameter("clientSearch", clientSearch));
        parameters.push(new Parameter("serialNumber", serialNumber));
        parameters.push(new Parameter("numDoc", numDoc));
        parameters.push(new Parameter("project", project));
        parameters.push(new Parameter("status", status));
        parameters.push(new Parameter("technician", selectedTechnician));
        parameters.push(new Parameter("assistanceType", selectedAssistanceType));
        parameters.push(new Parameter("subcontractor", selectedSubcontractor));
        parameters.push(new Parameter("initialDate", initialDate));
        parameters.push(new Parameter("endDate", endDate));
        parameters.push(new Parameter("carPlate", carPlate));
        parameters.push(new Parameter("priority", selectedAssistancePriority));
        parameters.push(new Parameter("supportNumber", supportNumber));

        return parameters;
    };

    const onEnter = () => {
        setCurrentPage(1);
        setGoToPage(1);
        fetchData(1, currentPageSize ?? 10, currentSorting);
    };

    const onButtonClick = () => {
        setCurrentPage(1);
        setGoToPage(1);
        fetchData(1, currentPageSize ?? 10, currentSorting);
    }

    const onRemoveFiltersClick = () => {
        setCurrentPage(1);
        setGoToPage(1);

        setClientSearch("");
        setSerialNumber("");
        setNumDoc("");
        setProject("");
        setStatus("");
        setSelectedTechnician("");
        setSelectedAssistanceType("");
        setReloadSearch(true);
        setSelectedSubcontractor("");
        setInitialDate("");
        setEndDate("");
        setCarPlate("");
        setSelectedAssistancePriority("");
        setSupportNumber("");
    };

    useEffect(() => {
        if (reloadSearch === true) {
            fetchData(currentPage ?? 1, currentPageSize ?? 5, currentSorting);
            setReloadSearch(false);
        }
    }, [reloadSearch]);

    useEffect(() => {
        getStatus();
        getTechnicians();
        getAssistanceTypes();
        getPriorities();
    }, []);

    return (
        <>
            <Row>
                <InputComponent
                    xl={1}
                    lg={2}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    type={"text"}
                    label={intl.formatMessage({
                        id: "Screens.Assistances.Filters.NumDoc",
                    })}
                    readOnly={isButtonCreateLoading || props.loading}
                    value={numDoc}
                    onEnter={onEnter}
                    onChange={(t: string) => setNumDoc(t)}
                />

                {isActiveErpSupportModule && (
                    <InputComponent
                        xl={2}
                        lg={3}
                        md={5}
                        sm={12}
                        xs={12}
                        style={{ width: "100%", height: "43px" }}
                        type={"text"}
                        label={intl.formatMessage({
                            id: "Screens.Assistances.Filters.SupportNumber",
                        })}
                        readOnly={isButtonCreateLoading || props.loading}
                        value={supportNumber}
                        onEnter={onEnter}
                        onChange={(t: string) => setSupportNumber(t)}
                    />
                )}

                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    type={"text"}
                    label={intl.formatMessage({
                        id: "Screens.Assistances.Filters.Client",
                    })}
                    readOnly={isButtonCreateLoading || props.loading}
                    value={clientSearch}
                    onEnter={onEnter}
                    onChange={(t: string) => setClientSearch(t)}
                />

                {isActiveCarPlate && (
                    <InputComponent
                        xl={2}
                        lg={3}
                        md={5}
                        sm={12}
                        xs={12}
                        style={{ width: "100%", height: "43px" }}
                        type={"text"}
                        label={intl.formatMessage({
                            id: "Screens.Assistances.Filters.CarPlate",
                        })}
                        readOnly={isButtonCreateLoading || props.loading}
                        value={carPlate}
                        onEnter={onEnter}
                        onChange={(t: string) => setCarPlate(t)}
                    />
                )}                

                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    type={"text"}
                    label={intl.formatMessage({
                        id: "Screens.Assistances.Filters.SerialNumber",
                    })}
                    readOnly={isButtonCreateLoading || props.loading}
                    value={serialNumber}
                    onEnter={onEnter}
                    onChange={(t: string) => setSerialNumber(t)}
                />

                {isActiveProjectModule && (
                    <>
                        {/* Mostrar componentes/colunas quando projectModuleValue for verdadeiro */}
                        <InputComponent
                            xl={2}
                            lg={3}
                            md={5}
                            sm={6}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"text"}
                            label={intl.formatMessage({
                                id: "Screens.Assistances.Filters.Project",
                            })}
                            readOnly={isButtonCreateLoading || props.loading}
                            value={project}
                            onEnter={onEnter}
                            onChange={(t: string) => setProject(t)}
                        />
                    </>
                )}

                <SelectComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Técnico"}
                    selectedItemValue={selectedTechnician}
                    items={techninians}
                    onChange={(t: string) => {
                        setSelectedTechnician(t);
                    }}
                    showLoadingSkeleton={isButtonCreateLoading || props.loading}
                />

                {/* Mostrar componentes/colunas quando fabricationModuleValue for verdadeiro */}
                <SelectComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Tipo de Assistência"}
                    selectedItemValue={selectedAssistanceType}
                    items={assistanceTypesComponent}
                    onChange={(t: string) => {
                        setSelectedAssistanceType(t);
                    }}
                    showLoadingSkeleton={isButtonCreateLoading || props.loading}
                />

                <MultiSelectComponent
                    xl={4}
                    lg={5}
                    md={5}
                    sm={6}
                    xs={12}
                    style={{ width: "50%" }}
                    label={intl.formatMessage({ id: "Screens.Assistances.Filters.Status" })}
                    items={listStatus}
                    setSelectedString={setStatus}
                    selectString={status}
                    isDisabled={isButtonCreateLoading || props.loading}
                />

                {isActiveOutsourcingModule &&
                    <>
                        <InputComponent
                            xl={2}
                            lg={3}
                            md={5}
                            sm={6}
                            xs={12}
                            style={{ width: "100%", height: "43px" }}
                            type={"text"}
                            label={intl.formatMessage({
                                id: "Screens.Assistances.Filters.Subcontractor",
                            })}
                            readOnly={isButtonCreateLoading || props.loading}
                            value={selectedSubcontractor}
                            onEnter={onEnter}
                            onChange={(t: string) => setSelectedSubcontractor(t)}
                        />
                    </>
                }

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                    style={{ width: "100%" }}
                    type={"date"}
                    onEnter={onEnter}
                    value={initialDate}
                    label={intl.formatMessage({ id: "Screens.Assistances.Filters.InitialDate" })}
                    readOnly={isButtonCreateLoading || props.loading}
                    onChange={(t: string) => setInitialDate(t)}
                />
                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={2}
                    style={{ width: "100%" }}
                    type={"date"}
                    onEnter={onEnter}
                    value={endDate}
                    label={intl.formatMessage({ id: "Screens.Assistances.Filters.FinalDate" })}
                    readOnly={isButtonCreateLoading || props.loading}
                    onChange={(t: string) => setEndDate(t)}
                />

                {isActivePriorityModule &&
                    <SelectComponent
                        xl={2}
                        lg={2}
                        md={2}
                        sm={2}
                        xs={2}
                        style={{ width: "100%", height: "43px" }}
                        label={"Prioridade"}
                        selectedItemValue={selectedAssistancePriority}
                        items={assistancePriority}
                        onChange={(t: string) => {
                            setSelectedAssistancePriority(t);
                        }}
                        showLoadingSkeleton={isButtonCreateLoading || props.loading}
                    />
                }
            </Row>

            <Row>
                <Col xl={6} lg={6} md={6} sm={12} xs={12} style={{ marginTop: "1em", display: "inline-flex", gap: "1rem" }}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "Common.Buttons.Search" })}
                        style={{ minWidth: "113px" }}
                        onClick={onButtonClick}
                        disabled={isButtonCreateLoading || props.loading}
                    />
                    <ButtonComponent
                        text={intl.formatMessage({
                            id: "Common.Buttons.RemoveFilters",
                        })}
                        style={{ minWidth: "113px" }}
                        onClick={onRemoveFiltersClick}
                        disabled={isButtonCreateLoading || props.loading}
                    />
                </Col>
            </Row>

            <div className="pageComponent" style={{ width: "100%" }}>
                <TableComponent
                    goToPage={goToPage}
                    loading={props.loading}
                    pageCount={pageCount}
                    columns={columns}
                    manualPagination={true}
                    fetchData={fetchData}
                    pageSizes={pageSizes}
                    initialPage={page}
                    initialPageSize={pageSize}
                    initialSortBy={initialSortBy}
                    data={data}
                    dontOrderFirstCollumn={true}
                />
            </div>
        </>
    );
}
